




import Vue from 'vue';
import {Color} from '@/interfaces/TaskInterfaces';

export default Vue.component('task-color-control', {
  name: 'TaskColorControl',
  props: {
    colorId: {
      type: Number,
      required: true
    },
    selectedColorId: {
      type: Number,
      required: false
    },
  },
  computed: {
    selected(): boolean {
      return Number(this.selectedColorId) > 0;
    },
    classObj(): any {
      return {
        'background-purple': this.selectedColorId === this.colorId && this.colorId === Color.PURPLE,
        'background-red': this.selectedColorId === this.colorId && this.colorId === Color.RED,
        'background-blue': this.selectedColorId === this.colorId && this.colorId === Color.BLUE,
        'background-green': this.selectedColorId === this.colorId && this.colorId === Color.GREEN,
        'background-yellow': this.selectedColorId === this.colorId && this.colorId === Color.YELLOW,
        'color-purple': this.colorId === Color.PURPLE,
        'color-red': this.colorId === Color.RED,
        'color-blue': this.colorId === Color.BLUE,
        'color-green': this.colorId === Color.GREEN,
        'color-yellow': this.colorId === Color.YELLOW
      }
    }
  },
  methods: {
    changeColor() {
      this.$emit('change-color', this.colorId);
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/tasks/TaskColorControl.vue